// fr strings for messages/upsell.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const upsell: Dict = {
  "upsell.creator.train.title": "Commence à entraîner avec Creator",
  "upsell.creator.train.lead":
    "L'entraînement de voix est inclus dans Creator.",
  "upsell.creator.train.tick1": "Entraîne des voix en illimité",
  "upsell.creator.train.tick2": "Vidéos Marble Run, 50 pièces par mois",
  "upsell.creator.train.tick3": "Tu gardes tout ce que ton abonnement inclut",
  "upsell.creator.train.cta": "Passer à Creator et entraîner",

  "upsell.creator.export.title": "Exporte en 1080p",
  "upsell.creator.export.lead": "Creator exporte tes vidéos en Full HD 1080p.",
  "upsell.creator.export.tick1": "Exports en 1080p",
  "upsell.creator.export.tick2": "Vidéos Marble Run, 50 pièces par mois",
  "upsell.creator.export.tick3": "Entraîne des voix en illimité",
  "upsell.creator.export.cta": "Passer à Creator et exporter en 1080p",

  "upsell.creator.marble.title": "Marble Run est inclus dans Creator",
  "upsell.creator.marble.lead":
    "Transforme tes covers en vidéos Marble Run, prêtes pour TikTok et Reels.",
  "upsell.creator.marble.tick1": "50 pièces Marble Run chaque mois",
  "upsell.creator.marble.tick2": "Exports du studio en 1080p",
  "upsell.creator.marble.tick3": "Entraîne des voix en illimité",
  "upsell.creator.marble.cta": "Passer à Creator et faire un Marble Run",

  "upsell.creator.video.title": "Les vidéos sont incluses dans Creator",
  "upsell.creator.video.lead":
    "Transforme tes covers en vidéos à partager sur TikTok et Reels.",
  "upsell.creator.video.tick1": "Vidéos à partager, 50 pièces par mois",
  "upsell.creator.video.tick2": "Exports du studio en 1080p",
  "upsell.creator.video.tick3": "Entraîne des voix en illimité",
  "upsell.creator.video.cta": "Passer à Creator et faire ma vidéo",

  "upsell.creator.samplesOne":
    "Tes pistes vocales sont prêtes : {files} fichier, {duration}. ",
  "upsell.creator.samplesMany":
    "Tes pistes vocales sont prêtes : {files} fichiers, {duration}. ",
  "upsell.creator.nothing": "Rien",
  "upsell.creator.today": "aujourd'hui",
  "upsell.creator.toPayToday": "à payer aujourd'hui",
  "upsell.creator.thenMonth": "puis {price} par mois",
  "upsell.creator.credited":
    "Le reste de ton mois en cours est déduit. Annule quand tu veux.",
  "upsell.creator.priceError":
    "Impossible de charger le prix de ton nouvel abonnement. Tu peux changer d'abonnement à tout moment depuis les Paramètres.",
  "upsell.creator.upgrading": "Changement en cours...",
  "upsell.creator.notNow": "Pas maintenant",
  "upsell.creator.payFailed":
    "Le paiement n'est pas passé, donc rien n'a changé. Vérifie ta carte dans les Paramètres et réessaie.",

  "upsell.coins.title": "Obtiens des pièces Pro",
  "upsell.coins.subtitle": "Chaque pièce crée une vidéo à partager",
  "upsell.coins.coinAlt": "Pièce Pro",
  "upsell.coins.useMarble": "Vidéos Marble Run",
  "upsell.coins.useLyric": "Vidéos avec paroles",
  "upsell.coins.useTemplates": "Tous les modèles de vidéo",
  "upsell.coins.bestValue": "MEILLEUR PRIX",
  "upsell.coins.mostCoins": "LE PLUS DE PIÈCES",
  "upsell.coins.proCoins": "pièces Pro",
  "upsell.coins.each": "{price}/pièce",
  "upsell.coins.purchase": "Acheter",
  "upsell.coins.footer":
    "Les pièces Pro sont ajoutées instantanément et n'expirent jamais. 1 pièce = 1 vidéo.",
};

export default upsell;
